import { Sparkles } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SparklesIcon = createLucideIcon(Sparkles);
